var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProviderServiceMngtIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 13H8.1C7.605 13 7.2 12.55 7.2 12H0.909V16C0.909 17.1 1.719 18 2.709 18H15.3C16.29 18 17.1 17.1 17.1 16V12H10.8C10.8 12.55 10.395 13 9.9 13ZM16.2 4H12.6C12.6 1.79 10.989 0 9 0C7.011 0 5.4 1.79 5.4 4H1.8C0.81 4 0 4.9 0 6V9C0 10.11 0.801 11 1.8 11H7.2V10C7.2 9.45 7.605 9 8.1 9H9.9C10.395 9 10.8 9.45 10.8 10V11H16.2C17.19 11 18 10.1 18 9V6C18 4.9 17.19 4 16.2 4ZM7.2 4C7.2 2.9 8.01 2 9 2C9.99 2 10.8 2.9 10.8 4H7.191H7.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderServiceMngtIcon);
export default __webpack_public_path__ + "static/media/provider-service-mngt-icon.1e81a3086fd46151bc2fb74d1edd89d6.svg";
export { ForwardRef as ReactComponent };